import { render, staticRenderFns } from "./img-cutter.vue?vue&type=template&id=51c92187&"
import script from "./img-cutter.vue?vue&type=script&lang=js&"
export * from "./img-cutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c92187')) {
      api.createRecord('51c92187', component.options)
    } else {
      api.reload('51c92187', component.options)
    }
    module.hot.accept("./img-cutter.vue?vue&type=template&id=51c92187&", function () {
      api.rerender('51c92187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/components/img-cutter.vue"
export default component.exports